const ACCESS_TOKEN_KEY = "accessToken";
const REFRESH_TOKEN_KEY = "refreshToken";
const TOKEN_TYPE_KEY = "tokenType";
const LOGIN_USER_KEY = "loginUser";
const AUTHENTICATED_KEY = "isAuthenticated";

export const routeWhiteList = ["/login"];

export interface StoredUser {
  username: string;
  role?: string;
}

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY) || "";
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_TOKEN_KEY) || "";
}

export function getTokenType() {
  return localStorage.getItem(TOKEN_TYPE_KEY) || "Bearer";
}

export function isAuthenticated() {
  return Boolean(getAccessToken());
}

export function isWhiteListedRoute(pathname: string) {
  return routeWhiteList.some((path) => pathname === path || pathname.startsWith(`${path}/`));
}

export function setAuthSession(params: {
  accessToken: string;
  refreshToken?: string;
  tokenType?: string;
  user?: StoredUser;
}) {
  localStorage.setItem(AUTHENTICATED_KEY, "true");
  localStorage.setItem(ACCESS_TOKEN_KEY, params.accessToken);
  localStorage.setItem(REFRESH_TOKEN_KEY, params.refreshToken || "");
  localStorage.setItem(TOKEN_TYPE_KEY, params.tokenType || "Bearer");
  if (params.user) {
    localStorage.setItem(LOGIN_USER_KEY, JSON.stringify(params.user));
  }
}

export function clearAuthSession() {
  localStorage.removeItem(AUTHENTICATED_KEY);
  localStorage.removeItem(LOGIN_USER_KEY);
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(TOKEN_TYPE_KEY);
}
